/* WALKO VOYAGE — configurateur en 3 étapes : breloques (drapeaux / cartes, argent / or) → support → gravure + options.
   Données : window.WV_PAYS (walko-voyage-pays.js) et WV.cfg (snippet wv-data). Commande : /cart/add.js → cadeaux → /checkout. */
(function () {
  'use strict';
  var root = document.querySelector('[data-wv-config]');
  if (!root || !window.WV_PAYS || !window.WV || !WV.cfg) return;
  var C = WV.cfg, $ = function (s, r) { return (r || root).querySelector(s); }, $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var PAYS = window.WV_PAYS.map(function (r) { return { c: r[0], n: r[1], z: r[2], fi: r[3], t: r[4], v: { 'd|AG': r[5], 'd|OR': r[6], 'c|AG': r[7], 'c|OR': r[8] }, k: norm(r[1]) }; });
  var PAR_CODE = {}; PAYS.forEach(function (p) { PAR_CODE[p.c] = p; });
  var FIN_LABEL = { AG: 'Argent', OR: 'Or 18K' };
  var st = { etape: 1, fin: 'AG', onglet: root.getAttribute('data-onglet') === 'cartes' ? 'c' : 'd', zone: '', q: '', selSeul: false,
             sel: {}, ordre: 0, supports: [], grav: {}, gravOuvert: {}, emballage: false, carte: false, carteMsg: '', assurance: false, assemblage: false };

  function norm(s) { return String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[’']/g, ' '); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function cle(t, c, f) { return t + '|' + c + '|' + f; }
  function nbBreloques() { var n = 0; for (var k in st.sel) n += st.sel[k].q; return n; }
  function prixBreloque(f) { return f === 'OR' ? C.prix.OR : C.prix.AG; }

  /* Rendu d'une breloque (drapeau flag-icons ou carte métal) */
  function breloque(t, p, f, w, grand) {
    var or = f === 'OR' ? ' is-or' : '', style = w ? ' style="--w:' + w + '"' : '';
    if (t === 'c') return '<span class="wv-ch wv-ch--carte' + or + '"' + style + '><i></i><b>' + esc(grand ? p.n : p.c) + '</b></span>';
    var fl = p.fi.indexOf('wv-') === 0 ? '<span class="wv-fi wv-fi-' + p.fi.slice(3) + '"></span>' : '<span class="fi fi-' + p.fi + '"></span>';
    return '<span class="wv-ch' + or + '"' + style + '>' + fl + '</span>';
  }

  /* ---------- Étape 1 : liste des pays ---------- */
  function listeFiltree() {
    var q = norm(st.q.trim()), out;
    out = PAYS.filter(function (p) {
      if (st.zone === 'fr' && !(p.z === 'fr' || p.c === 'FR')) return false;
      if (st.zone && st.zone !== 'fr' && p.z !== st.zone) return false;
      if (q && p.k.indexOf(q) === -1 && norm(p.c) !== q) return false;
      if (!p.v[st.onglet + '|AG']) return false; /* MAJ 28/10 : pays sans variante pour cet onglet (Israël n'existe qu'en drapeau) */
      if (st.selSeul && !(st.sel[cle(st.onglet, p.c, 'AG')] || st.sel[cle(st.onglet, p.c, 'OR')])) return false;
      return true;
    });
    if (!q && !st.zone && !st.selSeul) {
      var top = out.filter(function (p) { return p.t; }).sort(function (a, b) { return a.t - b.t; });
      out = top.concat(out.filter(function (p) { return !p.t; }));
    }
    return out;
  }
  function renderListe() {
    var l = listeFiltree(), h = [];
    l.forEach(function (p) {
      var s = st.sel[cle(st.onglet, p.c, st.fin)], autre = st.sel[cle(st.onglet, p.c, st.fin === 'AG' ? 'OR' : 'AG')];
      var info = autre ? '<small>' + autre.q + ' en ' + (st.fin === 'AG' ? 'or' : 'argent') + ' déjà choisie(s)</small>' : '';
      var action = s ? '<div class="wv-pas"><button type="button" data-moins="' + p.c + '" aria-label="Retirer ' + esc(p.n) + '">−</button><span>' + s.q + '</span><button type="button" data-plus="' + p.c + '" aria-label="Ajouter ' + esc(p.n) + '">+</button></div>'
                     : '<button type="button" class="wv-ajout" data-plus="' + p.c + '">+ Ajouter</button>';
      h.push('<div class="wv-ligne">' + breloque(st.onglet, p, st.fin) + '<div class="wv-ligne__nom">' + esc(p.n) + info + '</div>' + action + '</div>');
    });
    $('[data-wv-liste]').innerHTML = h.length ? h.join('') : '<p class="wv-vide">Aucun pays ne correspond. Essaie un autre nom (ex. « Maroc », « Réunion »).</p>';
    $('[data-wv-nb]').textContent = nbBreloques();
  }
  function ajouter(code, delta) {
    var k = cle(st.onglet, code, st.fin), s = st.sel[k];
    if (!s && delta > 0) { s = st.sel[k] = { t: st.onglet, c: code, f: st.fin, q: 0, o: ++st.ordre }; }
    if (!s) return;
    s.q += delta;
    if (s.q <= 0) delete st.sel[k];
    if (delta > 0) montrerBreloque(st.onglet, PAR_CODE[code], st.fin);
    nettoyerGravures(); maj();
  }

  /* ---------- Galerie (swipe : WV.galerie dans walko-voyage.js) ---------- */
  var gal = WV.galerie($('[data-wv-gal]'));
  function montrerBreloque(t, p, f) {
    var big = $('[data-wv-gal-big]');
    if (!big) return;
    big.className = 'wv-big' + (f === 'OR' ? ' is-or' : '');
    big.innerHTML = '<div class="wv-big__clip"></div><div class="wv-big__ring"></div>' + breloque(t, p, f, null, true) + '<p class="wv-big__nom">' + esc(p.n) + ' · ' + FIN_LABEL[f] + '</p>';
    big.hidden = false;
    if (gal) gal.montrerBig();
  }

  /* ---------- Étape 2 : supports ---------- */
  /* Support remplacé par le « Support offert » 0 € : le moins cher (le premier à prix égal), dès 10 breloques ; −1 sinon */
  function indexSupportOffert(n) {
    if (n < C.paliers.support || !st.supports.length) return -1;
    var best = 0;
    st.supports.forEach(function (s, i) { if (C.supports[s.t].choix[s.c].prix < C.supports[st.supports[best].t].choix[st.supports[best].c].prix) best = i; });
    return best;
  }
  function renderSupports() {
    var n = nbBreloques(), h = [];
    $('[data-wv-support-sous]').innerHTML = n >= C.paliers.support
      ? '<span class="wv-vert">Bravo, ton premier support est offert</span> (il passe à 0 € dans ton panier).'
      : 'Optionnel. Ton support est offert dès ' + C.paliers.support + ' breloques (encore ' + (C.paliers.support - n) + ').';
    var iOffert = indexSupportOffert(n);
    st.supports.forEach(function (s, i) {
      var type = C.supports[s.t], ch = type.choix[s.c];
      var pill = i === iOffert ? '<span class="wv-pill wv-pill--vert">Offert</span>' : (st.supports.length - (iOffert > -1 ? 1 : 0) > 1 ? '<span class="wv-pill wv-pill--vert">1 acheté = 1 offert</span>' : '');
      h.push('<div class="wv-support"><div class="wv-support__tete"><span>Support n°' + (i + 1) + ' ' + pill + '</span><button type="button" class="wv-support__sup" data-sup-retirer="' + i + '" aria-label="Retirer ce support">🗑</button></div>'
        + '<div class="wv-types">' + C.supports.map(function (ty, j) { return '<button type="button" class="' + (j === s.t ? 'is-on' : '') + '" data-sup-type="' + i + ':' + j + '">' + esc(ty.nom) + '</button>'; }).join('') + '</div>'
        + '<p class="wv-capa">' + esc(type.capa) + '</p>'
        + '<div class="wv-choix">' + type.choix.map(function (x, j) { return '<button type="button" class="' + (j === s.c ? 'is-on' : '') + '" data-sup-choix="' + i + ':' + j + '"><img src="' + x.img + '" alt="" loading="lazy">' + esc(x.label) + '<b>' + WV.euros(x.prix) + '</b></button>'; }).join('') + '</div></div>');
      void ch;
    });
    $('[data-wv-supports]').innerHTML = h.join('');
    $('[data-wv-ajout-support] span').textContent = st.supports.length ? '+ Ajouter un autre support' : '+ Ajouter un support';
  }

  /* ---------- Étape 3 : gravures ---------- */
  function unitesDrapeaux() {
    var u = [];
    Object.keys(st.sel).map(function (k) { return st.sel[k]; }).filter(function (s) { return s.t === 'd'; })
      .sort(function (a, b) { return a.o - b.o; })
      .forEach(function (s) { for (var i = 1; i <= s.q; i++) u.push({ k: cle('d', s.c, s.f) + '#' + i, s: s }); });
    return u;
  }
  function nettoyerGravures() {
    var ok = {}; unitesDrapeaux().forEach(function (u) { ok[u.k] = 1; });
    Object.keys(st.grav).forEach(function (k) { if (!ok[k]) { delete st.grav[k]; delete st.gravOuvert[k]; } });
  }
  function renderGravures() {
    var u = unitesDrapeaux();
    if (!u.length) { $('[data-wv-gravures]').innerHTML = '<p class="wv-vide">Aucune breloque drapeau dans ta sélection.</p>'; return; }
    $('[data-wv-gravures]').innerHTML = u.map(function (x) {
      var p = PAR_CODE[x.s.c], ouvert = st.gravOuvert[x.k] || st.grav[x.k];
      return '<div class="wv-grav"><div class="wv-grav__tete">' + breloque('d', p, x.s.f) + '<div>' + esc(p.n) + '<small>' + FIN_LABEL[x.s.f] + ' (acier 316L)</small></div>'
        + (ouvert ? '' : '<button type="button" class="wv-grav__btn" data-grav-ouvrir="' + x.k + '">⊕ Ajouter une gravure</button>') + '</div>'
        + (ouvert ? '<div class="wv-grav__champ"><input type="text" maxlength="39" placeholder="Ex. Bali, août 2024, avec toi" value="' + esc(st.grav[x.k] || '') + '" data-grav="' + x.k + '" aria-label="Texte gravé pour ' + esc(p.n) + '"><small>39 caractères max.</small><button type="button" class="wv-support__sup" data-grav-sup="' + x.k + '" aria-label="Supprimer la gravure">🗑</button></div>' : '')
        + '</div>';
    }).join('');
  }

  /* ---------- Totaux = remises réelles de la caisse (MAJ 22/10) ----------
     - breloques : −50 % Shopify, remise arrondie au centime inférieur par unité (WV.remiseBreloque) ;
     - supports : dès 10 breloques le moins cher passe à 0 € (produit « Support offert »), puis 1 support acheté = 1 offert
       sur les supports payants restants (WV.prixSupports). */
  function calcul() {
    var lignes = [], brut = 0, n = nbBreloques(), bogo = 0;
    Object.keys(st.sel).map(function (k) { return st.sel[k]; }).sort(function (a, b) { return a.o - b.o; }).forEach(function (s) {
      var p = PAR_CODE[s.c], pu = prixBreloque(s.f);
      lignes.push({ html: breloque(s.t, p, s.f, '30px'), nom: p.n + ' · ' + (s.t === 'd' ? 'drapeau' : 'carte') + ' ' + FIN_LABEL[s.f].toLowerCase(), q: s.q, m: pu * s.q });
      brut += pu * s.q;
      bogo += WV.remiseBreloque(pu, s.q);
    });
    var sup = st.supports.map(function (s) { var x = C.supports[s.t].choix[s.c]; return { label: C.supports[s.t].nom + ' · ' + x.label, prix: x.prix, id: x.id }; });
    sup.forEach(function (x) { lignes.push({ html: '', nom: x.label, q: 1, m: x.prix, support: 1 }); brut += x.prix; });
    var ps = WV.prixSupports(sup.map(function (x) { return x.prix; }), n), offertSupport = ps.offertEchange, bxgySupports = ps.bxgy;
    var nGrav = Object.keys(st.grav).filter(function (k) { return st.grav[k] && st.grav[k].trim(); }).length;
    if (nGrav) { lignes.push({ html: '', nom: 'Gravure', q: nGrav, m: nGrav * C.prix.gravure }); brut += nGrav * C.prix.gravure; }
    var asm = assemblageVariante(n);
    if (st.assemblage && st.supports.length) { lignes.push({ html: '', nom: 'Assemblage prêt à porter', q: 1, m: asm.prix }); brut += asm.prix; }
    if (st.assurance) { lignes.push({ html: '', nom: 'Assurance livraison', q: 1, m: C.prix.assurance }); brut += C.prix.assurance; }
    if (st.emballage) { lignes.push({ html: '', nom: 'Emballage cadeau', q: 1, m: C.prix.emballage }); brut += C.prix.emballage; }
    if (st.carte) { lignes.push({ html: '', nom: 'Carte écrite à la main', q: 1, m: C.prix.carte }); brut += C.prix.carte; }
    return { lignes: lignes, brut: brut, bogo: bogo, bxgySupports: bxgySupports, offertSupport: offertSupport, total: brut - bogo - bxgySupports - offertSupport, n: n, nGrav: nGrav };
  }
  function assemblageVariante(n) { var a = C.assemblage || []; for (var i = 0; i < a.length; i++) if (n <= a[i].max) return a[i]; return a[a.length - 1] || { prix: 0 }; }
  function renderBarre(r) {
    $('[data-wv-total]').textContent = WV.euros(r.total);
    var b = $('[data-wv-total-barre]'); b.hidden = r.total === r.brut; b.textContent = WV.euros(r.brut);
    var n = r.n, S = C.paliers, msg;
    $('[data-wv-prog]').style.width = Math.min(n, S.support) / S.support * 100 + '%';
    $$('[data-wv-pt]').forEach(function (pt) { pt.classList.toggle('is-on', n >= +pt.getAttribute('data-wv-pt')); });
    if (n < S.surprise) msg = 'Ajoute 1 breloque et reçois <b>un cadeau surprise</b>';
    else if (n < S.kit) msg = '🎉 Cadeau surprise débloqué ! Encore ' + (S.kit - n) + ' pour <b>le kit de voyage offert</b>';
    else if (n < S.support) msg = '🎉 Kit de voyage débloqué ! Encore ' + (S.support - n) + ' pour <b>ton support offert</b>';
    else msg = '🎉 Tout est débloqué : <b>cadeau surprise, kit de voyage et support offert</b>';
    $('[data-wv-msg]').innerHTML = msg;
    $('[data-wv-prec]').hidden = st.etape === 1;
    $('[data-wv-suiv]').textContent = st.etape === 3 ? 'Commander' : 'Suivant';
  }
  function renderRecap(r) {
    var h = r.lignes.map(function (l) { return '<div class="wv-recap__l"><span>' + l.html + esc(l.nom) + (l.q > 1 ? ' × ' + l.q : '') + '</span><span>' + WV.euros(l.m) + '</span></div>'; });
    if (!h.length) h.push('<p class="wv-vide">Ta sélection est vide.</p>');
    h.push('<div class="wv-recap__l"><span>Sous-total</span><span>' + WV.euros(r.brut) + '</span></div>');
    if (r.bogo) h.push('<div class="wv-recap__l wv-vert"><span>1 achetée = 1 offerte (−50 % par breloque)</span><span>−' + WV.euros(r.bogo) + '</span></div>');
    if (r.bxgySupports) h.push('<div class="wv-recap__l wv-vert"><span>1 support acheté = 1 offert</span><span>−' + WV.euros(r.bxgySupports) + '</span></div>');
    if (r.offertSupport) h.push('<div class="wv-recap__l wv-vert"><span>Support offert dès 10 breloques</span><span>−' + WV.euros(r.offertSupport) + '</span></div>');
    if (r.n >= C.paliers.surprise) h.push('<div class="wv-recap__l wv-vert"><span>🎁 Cadeau surprise</span><span>Offert</span></div>');
    if (r.n >= C.paliers.kit) h.push('<div class="wv-recap__l wv-vert"><span>🧳 Kit de voyage</span><span>Offert</span></div>');
    h.push('<div class="wv-recap__tot"><span>Total</span><span>' + WV.euros(r.total) + '</span></div><p class="wv-note">Remises appliquées automatiquement au paiement. Frais de livraison calculés à l’étape suivante.</p>');
    $('[data-wv-recap-corps]').innerHTML = h.join('');
  }
  function maj() {
    renderListe();
    if (st.etape === 2) renderSupports();
    if (st.etape === 3) { renderGravures(); var bloc = $('[data-wv-assemblage-bloc]'); bloc.hidden = !st.supports.length; $('[data-wv-assemblage-prix]').textContent = WV.euros(assemblageVariante(nbBreloques()).prix); }
    var r = calcul(); renderBarre(r); renderRecap(r);
  }
  function erreur(t) { var e = $('[data-wv-erreur]'); e.hidden = !t; e.textContent = t || ''; }
  function allerA(n) {
    if (n > 1 && nbBreloques() === 0) { erreur('Choisis au moins une breloque pour continuer.'); return; }
    erreur('');
    if (n === 2 && !st.supports.length && nbBreloques() >= C.paliers.support) st.supports.push({ t: 0, c: 0 });
    st.etape = n;
    $$('[data-wv-etape]').forEach(function (el) { el.hidden = +el.getAttribute('data-wv-etape') !== n; });
    maj();
    var top = root.querySelector('.wv-cfg').getBoundingClientRect().top + window.pageYOffset - 90;
    if (window.pageYOffset > top) window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- Commande ---------- */
  function lignesPanier() {
    var items = [], parVar = {};
    Object.keys(st.sel).map(function (k) { return st.sel[k]; }).sort(function (a, b) { return a.o - b.o; }).forEach(function (s) {
      var p = PAR_CODE[s.c], vid = p.v[s.t + '|' + s.f], gravees = 0;
      if (s.t === 'd') {
        for (var i = 1; i <= s.q; i++) {
          var txt = (st.grav[cle('d', s.c, s.f) + '#' + i] || '').trim();
          if (!txt) continue;
          gravees++;
          var g = 'g' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
          items.push({ id: vid, quantity: 1, properties: { 'Gravure': txt, '_wv_grp': g } });
          items.push({ id: C.variantes.gravure, quantity: 1, properties: { 'Breloque': p.n + ' — ' + FIN_LABEL[s.f], 'Texte': txt, '_wv_grp': g } });
        }
      }
      if (s.q - gravees > 0) items.push({ id: vid, quantity: s.q - gravees });
    });
    var iOffert = indexSupportOffert(nbBreloques());
    st.supports.forEach(function (s, i) { var x = C.supports[s.t].choix[s.c], id = (i === iOffert && x.offert) ? x.offert : x.id; parVar[id] = (parVar[id] || 0) + 1; });
    Object.keys(parVar).forEach(function (id) { items.push({ id: +id, quantity: parVar[id] }); });
    if (st.assemblage && st.supports.length) items.push({ id: assemblageVariante(nbBreloques()).id, quantity: 1 });
    if (st.assurance) items.push({ id: C.variantes.assurance, quantity: 1 });
    if (st.emballage) items.push({ id: C.variantes.emballage, quantity: 1 });
    if (st.carte) items.push({ id: C.variantes.carteMain, quantity: 1, properties: st.carteMsg.trim() ? { 'Message': st.carteMsg.trim() } : {} });
    return items;
  }
  function commander(btn) {
    if (!nbBreloques()) { erreur('Choisis au moins une breloque.'); return; }
    btn.disabled = true; btn.textContent = 'Ajout au panier…'; erreur('');
    WV.jsonFetch('/cart/add.js', { items: lignesPanier() })
      .then(function () { return WV.reconcilier(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (e) {
        btn.disabled = false; btn.textContent = 'Commander';
        erreur('Impossible d’ajouter ta sélection au panier : ' + e.message + '. Réessaie ou écris-nous à contact@walko-shop.com.');
      });
  }

  /* ---------- Événements ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, [data-plus], [data-moins]');
    if (!t || !root.contains(t)) return;
    var a;
    if ((a = t.getAttribute('data-plus'))) return ajouter(a, 1);
    if ((a = t.getAttribute('data-moins'))) return ajouter(a, -1);
    if ((a = t.getAttribute('data-wv-fin'))) { st.fin = a; $$('[data-wv-fin]').forEach(function (b) { b.classList.toggle('is-on', b === t); }); return renderListe(); }
    if ((a = t.getAttribute('data-wv-onglet'))) { st.onglet = a === 'cartes' ? 'c' : 'd'; ongletUI(); return renderListe(); }
    if (t.parentNode.hasAttribute && t.parentNode.hasAttribute('data-wv-puces')) { st.zone = t.getAttribute('data-z'); $$('[data-wv-puces] button').forEach(function (b) { b.classList.toggle('is-on', b === t); }); return renderListe(); }
    if (t.hasAttribute('data-wv-vider')) { if (nbBreloques() && confirm('Vider toute ta sélection ?')) { st.sel = {}; st.grav = {}; maj(); } return; }
    if ((a = t.getAttribute('data-sup-type'))) { var x = a.split(':'); st.supports[+x[0]] = { t: +x[1], c: 0 }; return maj(); }
    if ((a = t.getAttribute('data-sup-choix'))) { var y = a.split(':'); st.supports[+y[0]].c = +y[1]; return maj(); }
    if ((a = t.getAttribute('data-sup-retirer'))) { st.supports.splice(+a, 1); return maj(); }
    if (t.hasAttribute('data-wv-ajout-support')) { st.supports.push({ t: 0, c: 0 }); return maj(); }
    if ((a = t.getAttribute('data-grav-ouvrir'))) { st.gravOuvert[a] = 1; renderGravures(); var i = root.querySelector('[data-grav="' + a + '"]'); if (i) i.focus(); return; }
    if ((a = t.getAttribute('data-grav-sup'))) { delete st.grav[a]; delete st.gravOuvert[a]; return maj(); }
    if (t.hasAttribute('data-wv-suiv')) { return st.etape < 3 ? allerA(st.etape + 1) : commander(t); }
    if (t.hasAttribute('data-wv-prec')) return allerA(st.etape - 1);
    if (t.hasAttribute('data-wv-recap-ouvrir')) { $('[data-wv-recap]').classList.add('is-open'); return; }
    if (t.hasAttribute('data-wv-recap-fermer')) { $('[data-wv-recap]').classList.remove('is-open'); return; }
  });
  $('[data-wv-recap]').addEventListener('click', function (e) { if (e.target === e.currentTarget) e.currentTarget.classList.remove('is-open'); });
  $('[data-wv-cherche]').addEventListener('input', function (e) { st.q = e.target.value; renderListe(); });
  $('[data-wv-sel]').addEventListener('change', function (e) { st.selSeul = e.target.checked; renderListe(); });
  root.addEventListener('input', function (e) {
    var k = e.target.getAttribute('data-grav');
    if (k) { st.grav[k] = e.target.value.slice(0, 39); var r = calcul(); renderBarre(r); renderRecap(r); }
    if (e.target.hasAttribute('data-wv-carte-msg')) st.carteMsg = e.target.value;
  });
  root.addEventListener('change', function (e) {
    if (e.target.hasAttribute('data-wv-emballage')) { st.emballage = e.target.checked; maj(); }
    if (e.target.hasAttribute('data-wv-assurance')) { st.assurance = e.target.checked; maj(); }
    if (e.target.hasAttribute('data-wv-assemblage')) { st.assemblage = e.target.checked; maj(); }
    if (e.target.hasAttribute('data-wv-carte')) { st.carte = e.target.checked; $('[data-wv-carte-msg]').hidden = !st.carte; maj(); }
  });
  function ongletUI() { $$('[data-wv-onglet]').forEach(function (b) { var on = (b.getAttribute('data-wv-onglet') === 'cartes') === (st.onglet === 'c'); b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on ? 'true' : 'false'); }); }
  ongletUI(); maj();
})();
